module.exports = __webpack_public_path__ + "img/7.6da8baa5.jpg";